export default __webpack_public_path__ + "static/Monitoring-aba6f290b2a4917973dc9a40fd6032a9.png";